import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { clientWallet, clientWalletType } from '../../types/slices/clientWalletType'

const initialState: clientWalletType =
{
    status: ApiStatus.FETCHED,
    clientWallets: [],
    clientWalletSelected: {} as clientWallet,
    errorMessage: undefined,
    action: ''
}

const clientWalletSlice = createSlice({
    name: 'clientWalletSlice',
    initialState,
    reducers: {
        onFetchClientWallets (state, { payload }: { payload: clientWallet[]}) {
            state.status = ApiStatus.FETCHED
            state.clientWallets = payload
            state.errorMessage = undefined
        },
        onSetSelectedClientWallet (state, { payload }: { payload: clientWallet }) {
            state.clientWalletSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectClientWalletState = (state: RootState) => state.clientWalletSlice
export default clientWalletSlice.reducer
export const {
    onFetchClientWallets,
    onSetSelectedClientWallet,
    changeStatus,
    setAction,
} = clientWalletSlice.actions
